import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { TruncateModule } from "ng2-truncate";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { ComponentsModule } from "../../../components/components.module";
import { ConfigurableInputsModule } from "../../../components/configurable/inputs/configurable-inputs.module";
import { BodySystemsComponent } from "./body-systems/body-systems";
import MedicationDiscontinuePage from "./medication-discontinue/medication-discontinue";
import MedicationEditPage from "./medication-edit/medication-edit";
import { MedicationsPage } from "./medications";

@NgModule({
  entryComponents: [MedicationEditPage, MedicationDiscontinuePage],
  declarations: [
    MedicationsPage,
    MedicationEditPage,
    MedicationDiscontinuePage,
    BodySystemsComponent,
  ],
  imports: [
    IonicPageModule.forChild(MedicationsPage),
    TranslateModule.forChild(),
    CommonComponentsModule,
    NgSelectModule,
    ComponentsModule,
    TruncateModule,
    ConfigurableInputsModule,
  ],
  exports: [BodySystemsComponent],
})
export class MedicationsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/medications/medications.module.ts